import React from 'react';
import moment from 'moment';

import InOutDashboardContext from '../../services/inOutDashboard/InOutDashboardContext';

import { DATE_TIME_FORMAT } from '../../utilities/constants';

import Styles from '../../styles/componentStyle/inOutDashboard/InOutDashboard.scss';

/**
 * 入退場現場詳細テーブル
 * */
export const FieldTableLayout = () => {
  // 画面表示
  return (
    <InOutDashboardContext.Consumer>
      {({ state }) => (
        <div className={`${Styles.fieldTable} dashboard-table`}>
          <table className='dashboard-table__table'>
            <tbody>
              <tr className='dashboard-table__tr'>
                <td className='dashboard-table__label'>
                  <span className='label'>{data.title.fieldName}</span>
                </td>
                <td className='dashboard-table__content'>{state.field.name}</td>
              </tr>
              <tr className='dashboard-table__tr'>
                <td className='dashboard-table__label'>
                  <span className='label'>{data.title.dueDate}</span>
                </td>
                <td className='dashboard-table__content'>
                  {moment(state.field.groundbreaking_date).format(
                    DATE_TIME_FORMAT.weekdaySlashDateFormat
                  )}
                  {data.hyphen}
                  {moment(state.field.complete_schedule_date).format(
                    DATE_TIME_FORMAT.weekdaySlashDateFormat
                  )}
                </td>
              </tr>
              <tr className='dashboard-table__tr'>
                <td className='dashboard-table__label'>
                  <span className='label'>{data.title.fieldAddress}</span>
                </td>
                <td className='dashboard-table__content'>
                  {state.field.address}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </InOutDashboardContext.Consumer>
  );
};

// 定数
const data = {
  title: {
    fieldName: '現場名',
    dueDate: '着工 - 竣工予定日',
    fieldAddress: '現場所在地',
  },
  hyphen: ' - ',
};



// WEBPACK FOOTER //
// ./src/components/tables/InOutDashboardFieldTable.jsx